import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { v4 as uuid } from 'uuid';
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import { NewEmbedUi, updateVisualMedia } from './visual_media_shared';

export default function VisualMediaEmbeds({
  mediaTypeOptions,
  parentName,
  selectedVisualMediaIds,
  visualMediaEmbeds,
  onBulkCheckboxClick,
  onChange
}) {
  const handleVisualMediaEmbedsChange = newEmbeds => onChange(newEmbeds);

  const addVisualMediaEmbed = () => {
    const newEmbed = {
      embedUrl: '',
      mediaType: mediaTypeOptions[0].value,
      tempId: uuid()
    };
    const newEmbeds = [...visualMediaEmbeds, newEmbed];
    handleVisualMediaEmbedsChange(newEmbeds);
  };

  const updateVisualMediaEmbed = (identifier, column, newValue) => {
    const newEmbeds = updateVisualMedia(visualMediaEmbeds, identifier, column, newValue);
    handleVisualMediaEmbedsChange(newEmbeds);
  };

  return (
    <Fragment>
      <div className="photo-grid">
        <button
          className="ds-text-primary photo-row"
          style={{ minHeight: '250px' }}
          type="button"
          onClick={addVisualMediaEmbed}
        >
          <FontAwesomeIcon className="mr-2" icon={faLink} size="xl"/>
          <div style={{ fontSize: '16px' }}>Add Buildout Media Link</div>
        </button>
        <NewEmbedUi
          isCustomer={false}
          mediaTypeOptions={mediaTypeOptions}
          parentName={parentName}
          selectedVisualMediaIds={selectedVisualMediaIds}
          updateVisualMediaEmbed={updateVisualMediaEmbed}
          visualMediaEmbeds={visualMediaEmbeds}
          onBulkCheckboxClick={onBulkCheckboxClick}
        />
      </div>
    </Fragment>
  );
}

VisualMediaEmbeds.propTypes = {
  mediaTypeOptions: PropTypes.array.isRequired,
  parentName: PropTypes.string.isRequired,
  selectedVisualMediaIds: PropTypes.array.isRequired,
  visualMediaEmbeds: PropTypes.arrayOf(PropTypes.shape({
    embedUrl: PropTypes.string,
    fetchThumbnailUrl: PropTypes.string,
    mediaType: PropTypes.string,
    id: PropTypes.number,
    sortOrder: PropTypes.number,
  })),
  onBulkCheckboxClick: PropTypes.func.isRequired,
  onChange: PropTypes.func
};
